import React from 'react';
import PropTypes from 'prop-types';

import DealField, { propTypes } from 'bundles/apex/deals/form/fields/field';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import ManagedInput from 'components/form/managed_input';

export function DealFieldWithUnits({
  changeDeal,
  deal,
  disabled,
  name,
  invalid,
  label,
  type = 'number',
  required,
  unitOptions,
  onUnitsChange,
  onValueChange,
}) {
  const unitsName = `${name}Units`;

  return (
    <div className="form-group-pair mt-3">
      <ManagedFormGroup
        className="flex-grow-1"
        disabled={disabled}
        hasError={invalid}
        label={label}
        name={name}
        required={required}
        type={type}
        value={deal[name]}
        onChange={changes => !onValueChange && changeDeal(changes)}
        onValueChange={onValueChange}
      />

      <div className="form-group">
        <ManagedInput
          disabled={disabled}
          name={unitsName}
          type="select"
          value={deal[unitsName]}
          onChange={changes => !onUnitsChange && changeDeal(changes)}
          onValueChange={onUnitsChange}
        >
          {unitOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </ManagedInput>
      </div>
    </div>
  );
}

DealFieldWithUnits.propTypes = {
  ...propTypes,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  unitOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  onUnitsChange: PropTypes.func,
  onValueChange: PropTypes.func,
};

export default DealField(DealFieldWithUnits);
